var map = {
	"./Certified Badge.png": "1fd1",
	"./Config.png": "c95d",
	"./Conversation.png": "e8a4",
	"./Conversation.svg": "4dfc",
	"./File.png": "b4c2",
	"./File.svg": "ca0f",
	"./Globe.png": "0f9f",
	"./Group 28814.png": "f7b1",
	"./Group 28820.png": "4636",
	"./Group 28824.png": "9cf0",
	"./Group 28859.png": "17c1",
	"./Logout.png": "69ef",
	"./Nabumbugu_distribution_August_2017_4.jpg": "3c35",
	"./Screenshot_3.png": "2fcb",
	"./admin.png": "059c",
	"./badge.svg": "76ab",
	"./brazil.png": "65f3",
	"./card-banner.png": "dd79",
	"./card-icon.png": "f406",
	"./coffee-bean.png": "45d7",
	"./colombia.png": "16b0",
	"./farm.png": "c6b8",
	"./farm_Honduras.jpg": "61e6",
	"./farm_Kenya.jpg": "745e",
	"./farm_Mexico.jpg": "60be",
	"./farm_Uganda.jpg": "bcbc",
	"./file-icon.png": "349b",
	"./flags.png": "6cc6",
	"./honduras.png": "2b1e",
	"./icons/Cherry.svg": "a00d",
	"./icons/File.svg": "15cf",
	"./icons/Files.svg": "ab3a",
	"./icons/Group 1-1.svg": "9a3b",
	"./icons/Group 1-2.svg": "f896",
	"./icons/Group 1-3.svg": "e6db",
	"./icons/Group 1-4.svg": "985e",
	"./icons/Group 1.svg": "22cf",
	"./icons/Group 1@2x.png": "b0f6",
	"./icons/Group 28813.png": "63f9",
	"./icons/Group 28813.svg": "e727",
	"./icons/Group 28813@2x.png": "bb8c",
	"./icons/Group 28814.svg": "9956",
	"./icons/Group 28815.svg": "2e30",
	"./icons/Group 28816.svg": "eeaa",
	"./icons/Group 28824.png": "44d1",
	"./icons/Logo-Bloom-Vorschaubild.png": "bb04",
	"./icons/Logo-Bloom-Vorschaubild@2x.png": "a12c",
	"./icons/Polygon 1.svg": "9e7d",
	"./icons/Welcome-white@2x.png": "4c40",
	"./icons/admin.png": "abb5",
	"./icons/admin1.png": "ec00",
	"./icons/arrow-circle.svg": "133d",
	"./icons/becamo-logo.png": "719e",
	"./icons/bucket-lg.png": "888a",
	"./icons/bucket-sm.png": "9b5f",
	"./icons/caret-cirlce-sm.png": "3ee4",
	"./icons/cog-lg.png": "f52c",
	"./icons/cog-sm.png": "1eb8",
	"./icons/config.png": "bce7",
	"./icons/dollar-sm.png": "460a",
	"./icons/dollar.png": "2004",
	"./icons/eye.png": "986d",
	"./icons/farm.png": "0c1f",
	"./icons/farm.svg": "a85b",
	"./icons/farmer-2.png": "b851",
	"./icons/farmer-2.svg": "32fd",
	"./icons/farmer-groups.svg": "1ccd",
	"./icons/farmer-lg.png": "c0c7",
	"./icons/farmer-sm.png": "efb3",
	"./icons/farmer-sm.svg": "8f30",
	"./icons/files-lg.png": "cafa",
	"./icons/files-sm.png": "a653",
	"./icons/finance.png": "5372",
	"./icons/full-potential@2x.png": "f9dc",
	"./icons/get-in-touch.svg": "d9ab",
	"./icons/girl-lg.png": "5c63",
	"./icons/girl-sm.png": "d25b",
	"./icons/glass-lg.png": "5efd",
	"./icons/glass-sm.png": "a7e4",
	"./icons/glass1-sm.png": "f6e4",
	"./icons/heart-lg.png": "fa71",
	"./icons/heart-sm.png": "2113",
	"./icons/home.svg": "4b8a",
	"./icons/hourglass.svg": "b197",
	"./icons/house-sm.png": "470b",
	"./icons/icon-subgroups.svg": "b85a",
	"./icons/icon_Region.svg": "a74d",
	"./icons/icon_coffee-bean.svg": "82f1",
	"./icons/inclusive.svg": "9560",
	"./icons/infra.png": "38f8",
	"./icons/loading-lg.png": "80cb",
	"./icons/loading-sm.png": "7009",
	"./icons/lock-sm.png": "6814",
	"./icons/logo.svg": "aa0d",
	"./icons/logout.png": "9492",
	"./icons/market.png": "36fa",
	"./icons/mix-2.png": "0ad3",
	"./icons/mobile-2.png": "85cc",
	"./icons/mobile.png": "18d1",
	"./icons/nut-2.png": "c333",
	"./icons/nut-2.svg": "3dae",
	"./icons/nut-lg.png": "fedf",
	"./icons/nut-sm.png": "ad48",
	"./icons/nut.svg": "d02b",
	"./icons/nut3.png": "3d41",
	"./icons/nut4.png": "7d45",
	"./icons/pattern-lg.png": "89f2",
	"./icons/pattern-sm.png": "b7a2",
	"./icons/pattern.svg": "724b",
	"./icons/pdf.svg": "5456",
	"./icons/people-sm.png": "e041",
	"./icons/regions-fg@2x.png": "d543",
	"./icons/regions.svg": "9adf",
	"./icons/reno.png": "4310",
	"./icons/resources-sm.png": "3626",
	"./icons/resources.svg": "87d6",
	"./icons/resources@2x.png": "2f7c",
	"./icons/rocket.png": "cd02",
	"./icons/rocket.svg": "a195",
	"./icons/search-glass.svg": "ccaf",
	"./icons/share.png": "8832",
	"./icons/story.png": "0b27",
	"./icons/tech-assist.png": "4def",
	"./icons/traceability.svg": "c3e1",
	"./icons/transparency@2x.png": "e274",
	"./icons/upload1.svg": "74d4",
	"./icons/user-lg.png": "6717",
	"./icons/user-sm.png": "0f54",
	"./icons/user.png": "f34a",
	"./icons/welcome.png": "697f",
	"./icons/woman.png": "c450",
	"./icons/woman.svg": "cd30",
	"./kenya.png": "e9a9",
	"./login-banner.png": "183a",
	"./login-gif.gif": "4f2f",
	"./logo (2).svg": "2cc6",
	"./logo-lg.png": "5439",
	"./logo-transparent.png": "0021",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./map-marker/006330.svg": "d36d",
	"./map-marker/2E4213.svg": "8151",
	"./map-marker/636466.svg": "9ddd",
	"./map-marker/66A183.svg": "4673",
	"./map-marker/69AA1A.svg": "4aa3",
	"./map-marker/A5CD8F.svg": "6586",
	"./map-marker/ED1C24.svg": "ff05",
	"./more-icon.png": "92e9",
	"./svg-icons/icon_Financing.svg": "f5de",
	"./svg-icons/icon_Information-Services.svg": "c921",
	"./svg-icons/icon_Infrastructure.svg": "2d6e",
	"./svg-icons/icon_Market-Access.svg": "d9f7",
	"./svg-icons/icon_Quality-Inputs.svg": "54c6",
	"./svg-icons/icon_Renovation.svg": "f749",
	"./svg-icons/user.svg": "c87d",
	"./team.jpg": "1efd",
	"./uganda.png": "7970"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";